import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Container } from "../../../container/src";
import { useMatchBreakpoint } from "../../../theme/src";
import { Content } from './Content';
export const ContentOnly = ({ description, filteredControls, isPreview, showControls, showDescription, title, }) => {
    const isBreakpointXl = useMatchBreakpoint('xl');
    const contentHeight = {
        l: 252,
        m: 282,
        s: 'auto',
        xl: 310,
    };
    const maxWidthContent = {
        l: '100%',
        m: 535,
        s: '100%',
        xl: isPreview ? 'unset' : 792,
    };
    return (_jsx(StyledContainer, { "$isBreakpointXl": isBreakpointXl, "$showDescription": showDescription, dataTestId: "appheader-container", flexDirection: { _: 'column', m: 'row' }, children: _jsx(Content, { contentHeight: contentHeight, description: description, filteredControls: filteredControls, maxWidthContent: maxWidthContent, showControls: showControls, showDescription: showDescription, showPicture: false, title: title }) }));
};
const StyledContainer = styled(Container).attrs(({ $isBreakpointXl, $showDescription }) => ({
    justifyContent: 'start',
    p: $showDescription && $isBreakpointXl
        ? '24px 616px 24px 32px !important'
        : '24px 32px',
    px: {
        l: 8,
        m: 6,
        s: 4,
    },
    py: { m: 6, s: 4 },
})) ``;
//# sourceMappingURL=ContentOnly.js.map